import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import { inclusionPendencies } from '../../../../../commons/order-checklist';

const ApproveFinAnalysisButton = ({ order }) => {
  const { hasPermissions, hasRoles } = useContext(AuthContext);

  // Para aprovar, o pedido precisa ter um editor atribuido (a distribuicao e
  // feita pelo gestor no campo "Editor"). Sem editor, o botao fica desabilitado.
  const hasEditor = !!order.editor_id;

  // FEAT-015: mesmo checklist do "Enviar para Análise" — o pedido pode ter
  // entrado na análise antes de os contadores mudarem (ex.: adicional de álbum).
  const pendencies = inclusionPendencies(order);

  const ready = hasEditor && pendencies.length === 0;

  return (
    <>
      {order.order_status === 'Análise financeira' &&
        (hasPermissions(['financial_analysis']) ||
          hasRoles(['administrator', 'master'])) && (
          <div className="col-6 col-md-3 col-xl-2 mt-2">
            <button
              className="btn btn-success btn-block col-12"
              type="button"
              disabled={!ready}
              data-bs-toggle={ready ? 'modal' : undefined}
              data-bs-target={ready ? '#modal-financial-approved' : undefined}
            >
              aprovar
            </button>

            {!hasEditor && (
              <small className="text-danger d-block mt-1">
                Selecione e salve o editor para aprovar.
              </small>
            )}

            {pendencies.length > 0 && (
              <small
                className="text-danger d-block mt-1"
                style={{ textTransform: 'none' }}
              >
                Pendências: {pendencies.join(' · ')}
              </small>
            )}
          </div>
        )}
    </>
  );
};

ApproveFinAnalysisButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    editor_id: PropTypes.string,
  }).isRequired,
};

export default ApproveFinAnalysisButton;
